import { put, delay } from 'redux-saga/effects';
import { changeOfferPrice } from '../../../reducers';

export function* delayInputOfferPrice() {
  yield delay(400);

  yield put(changeOfferPrice());
}
